module.exports = __webpack_public_path__ + "static/media/cancel-package_3.55adcacb.png";